var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLokker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.178,
    height: 51.976,
    viewBox: "0 0 47.178 51.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #242424;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Comum",
    "data-name": "Icon Comum",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    className: "cls-1",
    d: "M9.3,16.5H42.881a4.8,4.8,0,0,1,4.8,4.8V38.089a4.8,4.8,0,0,1-4.8,4.8H9.3a4.8,4.8,0,0,1-4.8-4.8V21.3A4.8,4.8,0,0,1,9.3,16.5Z",
    transform: "translate(-4.5 5.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    className: "cls-1",
    d: "M10.5,24.589v-9.6a11.994,11.994,0,1,1,23.988,0v9.6",
    transform: "translate(-0.905 -3)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokker);
export default __webpack_public_path__ + "static/media/Lokker.0b941b85aa07089f71de48bde6004ae9.svg";
export { ForwardRef as ReactComponent };